import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openPlanDropdown, setOpenPlanDropdown] = useState(null);
  const [isSticky, setIsSticky] = useState(false);

  // Sticky logic
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Mobile menu body class
  useEffect(() => {
    if (drawerOpen) {
      document.body.classList.add("mobile-menu-visible");
    } else {
      document.body.classList.remove("mobile-menu-visible");
      setOpenDropdown(null);
      setOpenPlanDropdown(null);
    }
  }, [drawerOpen]);

  const handleNavigate = () => setDrawerOpen(false);

  return (
    <>
      {/* Main Header (also sticky on scroll) */}
      <header className={`main-header header-style-one header-3 ${isSticky ? "is-sticky" : ""}`}>
        <div className="header-lower max-w-7xl mx-auto">
          <div className="main-box">
            <div className="nav-outer">
              <div className="logo-box">
                <div className="logo">
                  <Link to="/">
                    <img src="https://zealthixprod.blob.core.windows.net/$web/assets/images/logo.svg" alt="Zealthix Logo" />
                  </Link>
                </div>
              </div>

              <div className="outer-box">
                {/* Desktop Menu */}
                <nav className="nav main-menu">
                  <ul className="navigation">
                    <li><NavLink to="/" className={({ isActive }) => (isActive ? "current" : "")}>Home</NavLink></li>
                    <li className="dropdown">
                      <span>Plans</span>
                      <ul>
                        <li><NavLink to="/plans" className={({ isActive }) => (isActive ? "current" : "")}>Plans</NavLink></li>
                        <li><NavLink to="/plans-construct" className={({ isActive }) => (isActive ? "current" : "")}>Plans Construct</NavLink></li>
                        {/* <li><NavLink to="/plans-benefits" className={({ isActive }) => (isActive ? "current" : "")}>Plans Benefits</NavLink></li> */}
                      </ul>
                    </li>
                    <li className="dropdown">
                      <span>Terms &amp; Policies</span>
                      <ul>
                        <li><NavLink to="/term-of-use" className={({ isActive }) => (isActive ? "current" : "")}>Terms and Conditions</NavLink></li>
                        <li><NavLink to="/shipping-delivery-policy" className={({ isActive }) => (isActive ? "current" : "")}>Shipping &amp; Delivery</NavLink></li>
                        <li><NavLink to="/cancellation-policy" className={({ isActive }) => (isActive ? "current" : "")}>Cancellation Policy</NavLink></li>
                        <li><NavLink to="/privacy-policy" className={({ isActive }) => (isActive ? "current" : "")}>Privacy Policy</NavLink></li>
                      </ul>
                    </li>
                    <li><NavLink to="/contact" className={({ isActive }) => (isActive ? "current" : "")}>Contact</NavLink></li>
                  </ul>
                </nav>

                {/* Mobile Toggler */}
                <div className="mobile-nav-toggler" onClick={() => setDrawerOpen(true)}>
                  <span className="icon lnr-icon-bars" />
                </div>
              </div>

              <Link to="https://pwa.zealthix.com/zealthix" className="theme-btn btn-style-one">Login App</Link>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <div className="mobile-menu">
        <div className="menu-backdrop" onClick={() => setDrawerOpen(false)} />
        <nav className="menu-box">
          <div className="upper-box">
            <div className="nav-logo">
              <Link to="/" onClick={handleNavigate}>
                <img src="https://zealthixprod.blob.core.windows.net/$web/assets/images/logo.svg" width="120px" alt="Zealthix Logo" />
              </Link>
            </div>
            <div className="close-btn" onClick={() => setDrawerOpen(false)}>
              <i className="icon fa fa-times" />
            </div>
          </div>
          <ul className="navigation">
            <li><NavLink to="/" onClick={handleNavigate}>Home</NavLink></li>
            <li className="dropdown">
              <button
                type="button"
                onClick={() => setOpenPlanDropdown(openPlanDropdown === "plans" ? null : "plans")}
              >
                Plans <i className={`fa fa-angle-${openPlanDropdown === "plans" ? "up" : "down"}`} />
              </button>
              <ul style={{ display: openPlanDropdown === "plans" ? "block" : "none" }}>
                <li><NavLink to="/plans" onClick={handleNavigate}>Plans</NavLink></li>
                <li><NavLink to="/plans-construct" onClick={handleNavigate}>Plans Construct</NavLink></li>
                {/* <li><NavLink to="/plans-benefits" onClick={handleNavigate}>Plans Benefits</NavLink></li> */}
              </ul>
            </li>
            <li className="dropdown">
              <button
                type="button"
                onClick={() => setOpenDropdown(openDropdown === "terms" ? null : "terms")}
              >
                Terms &amp; Policies <i className={`fa fa-angle-${openDropdown === "terms" ? "up" : "down"}`} />
              </button>
              <ul style={{ display: openDropdown === "terms" ? "block" : "none" }}>
                <li><NavLink to="/term-of-use" onClick={handleNavigate}>Terms and Conditions</NavLink></li>
                <li><NavLink to="/shipping-delivery-policy" onClick={handleNavigate}>Shipping &amp; Delivery</NavLink></li>
                <li><NavLink to="/cancellation-policy" onClick={handleNavigate}>Cancellation</NavLink></li>
                <li><NavLink to="/privacy-policy" onClick={handleNavigate}>Privacy Policy</NavLink></li>
              </ul>
            </li>
            <li><NavLink to="/contact" onClick={handleNavigate}>Contact</NavLink></li>
          </ul>

          <ul className="contact-list-one">
            <li>
              {/* Contact Info Box */}
              <div className="contact-info-box">
                <i className="icon lnr-icon-phone-handset" />
                <span className="title">Call Now</span>
                <a href="tel:+917303047811">+91-730-304-7811</a>
              </div>
            </li>
            <li>
              {/* Contact Info Box */}
              <div className="contact-info-box">
                <span className="icon lnr-icon-envelope1" />
                <span className="title">Send Email</span>
                <a href="mailto:admin@zealthix.com">admin@zealthix.com</a>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Header;